module.exports = __webpack_public_path__ + "static/media/activeOn.fd11d75e.svg";